/* -------------------------------------------------------------------------- *
 * JavaScript Modules *
 * -------------------------------------------------------------------------- */
import MobileMenu from "./modules/mobile-menu";
import Lightbox from "./modules/lightbox";
import fixedMenuOnScroll from "./modules/fixed-menu";
import ToggleModule from "./modules/toggle-module";
import BlogLoadMore from "./modules/blog-load-more";
import ScrollAnimations from "./modules/scroll-animations";
import ActiveNavigation from "./modules/active-navigation";
import SmoothScroll from "./modules/smooth-scroll";
import InputPlaceholder from "./modules/input-placeholder";
//import SubmenuToggle from "./modules/main-menu";
//import Lightbox from "./modules/lightbox";
//import ContactMap from "./modules/contact-map";
//import SocialShare from './modules/social-share';
//import Animations from './modules/animations';

/* ----------------- *
 * Load on All Pages *
 * ----------------- */
document.addEventListener("DOMContentLoaded", () => {
	MobileMenu.init();
	Lightbox.init();
	fixedMenuOnScroll.init();
	ToggleModule.init();
	BlogLoadMore.init();
	ScrollAnimations.init();
	ActiveNavigation.init();
	SmoothScroll.init();
	InputPlaceholder.init();
	
});